import PreviewAndAssign from './PreviewAndAssign.view';

export default PreviewAndAssign;
